import request from './request'


//获取微信签名的接口请求  
export const addCard = (next,pathId) => {
  console.log('url',window.location.href.replace('#/', ''))
  request({
    url: 'jsConfig',
    data: {
      url: window.location.href.replace('#/', '')
    }
  }).then(result => {
    if (!result.data) return;
    let { appId, timestamp, nonceStr, signature } = result.data;
    console.log('result.data', appId, timestamp, nonceStr, signature)
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: appId, // 必填，公众号的唯一标识
      timestamp: timestamp, // 必填，生成签名的时间戳
      nonceStr: nonceStr, // 必填，生成签名的随机串
      signature: signature,// 必填，签名
      jsApiList: ['addCard'] // 必填，需要使用的JS接口列表
    })
  
    wx.ready(function () {
        console.log("JSSDK调用成功-----wx.ready-----新版本")
        wx.checkJsApi({
          jsApiList: [
            'addCard',
          ],
          success: function (res) {
            console.log('----ready-success----跳转了')
            // 跳转卡券
            //添加pathId的判断
            request({url: 'cardConfig',data:pathId?{channels_id:pathId}:{}}).then(response => {
              console.log('response',response)
              let cardExt = response.data.cardExt
              console.log('传递的参数cardExt', cardExt, 'cardId', response.data.cardId)
              if (next) {
                setTimeout(function () {
                  next()
                },500)
              }

              window.sessionStorage.setItem('isNotFirst', true)

              wx.addCard({
                cardList: [
                  {
                    cardId: response.data.cardId,
                    // cardId: 'pLmdv6tvJlTXWa2NI9TTme4VcPEQ',
                    cardExt: JSON.stringify(cardExt)
                  }
                ],
                success (res) {
                   //-----------2.3埋点-----------------------
                  _czc.push(["_trackEvent","渠道id"+this.pathId+"卡券领取页面","	点击【领取卡券】按钮"])
                  window.localStorage.setItem('openCardTime',Date.now())
                   //---------------------------------
                  console.log('卡券添加成功', res.cardList) // 卡券添加结果
                },
                fail (err) {
                  //-----------2.3埋点-----------------------
                  _czc.push(["_trackEvent", "渠道id"+this.pathId+"卡券领取页面","退出领取页面"])
                  let openCardTime = window.localStorage.getItem('openCardTime') || null
                  if (openCardTime) {
                      let gapTime = Math.ceil((Date.now() - openCardTime)/1000)
                     _czc.push(["_trackEvent","渠道id"+this.pathId+"卡券领取页面","停留时长",gapTime+"s"])
                     window.localStorage.removeItem("openCardTime")
                  }
                  //----------------------------------------------
                  console.log('卡券添加失败', err)
                }
              })
            })
            
          }
        })
    });

    wx.error(function (res) {
        console.log("JSSKD调用错误信息---------");
        console.log(res);
    });


  })
  
}

